// ============================================================
// cf-form-helpers.js � Reusable Form & API Helpers
// Load hanya pada halaman yang membutuhkan form submission.
//
// Dependencies: site.js (CF.toast)
//
// Provides CF.formHelpers with:
//   CF.formHelpers.escHtml(str)        � XSS-safe HTML escape
//   CF.formHelpers.formatAudit(date, user) � Audit date formatting
//   CF.formHelpers.setSubmitting(btnId, loading) � Toggle button loading state
//   CF.formHelpers.handleApiError(xhr) � Parse & toast API errors
//   CF.formHelpers.getDescendantIds(rootId, items, idField, parentField) � BFS tree descendant finder
// ============================================================

window.CF = window.CF || {};

CF.formHelpers = (function () {
    'use strict';

    /**
     * XSS-safe HTML escape.
     * @param {string} str
     * @returns {string}
     */
    function escHtml(str) {
        if (!str) return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    /**
     * Format audit date with optional user.
     * @param {string} dateStr � ISO date string
     * @param {string} [user] � username
     * @returns {string}
     */
    function formatAudit(dateStr, user) {
        if (!dateStr) return '-';
        var d = new Date(dateStr);
        var formatted = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) +
                        ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        return formatted + (user ? ' by ' + user : '');
    }

    /**
     * Toggle submit button loading state.
     * @param {string} btnId � Element ID of the button
     * @param {boolean} loading � true = show spinner, false = restore
     */
    function setSubmitting(btnId, loading) {
        var btn = document.getElementById(btnId);
        if (!btn) return;
        if (loading) {
            btn.disabled = true;
            btn.dataset.origHtml = btn.innerHTML;
            btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Saving...';
        } else {
            btn.disabled = false;
            btn.innerHTML = btn.dataset.origHtml || btn.innerHTML;
        }
    }

    /**
     * Parse API error response and show toast messages.
     * @param {object} xhr � jQuery XHR object
     */
    function handleApiError(xhr) {
        if (!xhr || !xhr.responseJSON) {
            CF.toast.error('An unexpected error occurred.');
            return;
        }
        var res = xhr.responseJSON;
        if (res.message) {
            CF.toast.error(res.message);
        }
        if (res.errors) {
            Object.keys(res.errors).forEach(function (k) {
                var msgs = res.errors[k];
                if (msgs && msgs.length) CF.toast.error(msgs[0]);
            });
        }
    }

    /**
     * Get all descendant IDs of a given root node using BFS traversal.
     * Generic utility for tree structures (menus, permissions, parameter configs, etc.).
     * @param {string} rootId � ID of the root node
     * @param {Array} items � Flat array of tree items
     * @param {string} [idField='id'] � Property name for the node ID
     * @param {string} [parentField='parentId'] � Property name for the parent ID
     * @returns {Array} Array of descendant IDs (excludes rootId itself)
     */
    function getDescendantIds(rootId, items, idField, parentField) {
        idField = idField || 'id';
        parentField = parentField || 'parentId';

        var childrenByParent = {};
        (items || []).forEach(function (item) {
            var pid = item[parentField];
            if (!pid) return;
            if (!childrenByParent[pid]) childrenByParent[pid] = [];
            childrenByParent[pid].push(item[idField]);
        });

        var result = [];
        var queue = [rootId];
        while (queue.length) {
            var currentId = queue.shift();
            var children = childrenByParent[currentId] || [];
            for (var i = 0; i < children.length; i++) {
                result.push(children[i]);
                queue.push(children[i]);
            }
        }
        return result;
    }

    return {
        escHtml:          escHtml,
        formatAudit:      formatAudit,
        setSubmitting:    setSubmitting,
        handleApiError:   handleApiError,
        getDescendantIds: getDescendantIds
    };
})();
